export const SELECT_VIEWSTYLE = 'SELECT_VIEWSTYLE'